'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Cookies from 'js-cookie';
import { useAtom } from 'jotai';

// lib files
import { sendPbsGtmEvent, EventData } from "@/lib/helpers/send-pbs-gtm-event";
import { signinModalAtom, SignInModalStateEnum } from '@/lib/atoms/signin-modal';
import { TMP_VIDEO_COOKIE, TMP_SHOW_COOKIE } from '@/lib/constants';

// types
import MyListButtonProps from '@/components/Button/MyList/MyListTypes';

// svg's
import PlusIcon from '@/public/svg/add.svg';

// styles
import styles from './MyListButton.module.scss';

const SignedOutMyListButton = (props: MyListButtonProps) => {
  const [_, setSigninModalOpen] = useAtom(signinModalAtom)
  const { style, video, show } = props;

  const handleClick = () => {
    setSigninModalOpen(SignInModalStateEnum.TrueWithMyListBlurb);

    let eventData: EventData = {
      feature_category: "my list",
      feature_name: "my list button",
      object_action_behavior: "prompts sign in modal",
      object_action: "click",
      object_type: "button",
      signed_in_status: false,
    }

    if (show) {
      eventData = {
        ...eventData,
        franchise_title: show.franchise?.title,
        object_name: "my list - add show to list",
        pbs_content_id: show.slug,
        show_title: show.title,
      }
      Cookies.set(
        TMP_SHOW_COOKIE, show.cid,
        {
          // set the cookie for only 5 minutes
          expires: 1/288, // 5 minutes is 1/288th of a day
        }
      );
    } else if (video) {
      eventData = {
        ...eventData,
        franchise_title: video.franchise?.title,
        object_name: "my list - add video to list",
        pbs_content_id: video.slug,
        show_title: video.show?.title,
        video_title: video.title,
        video_tp_media_id: video.legacy_tp_media_id,
        video_type: video.video_type,
      }
      Cookies.set(
        TMP_VIDEO_COOKIE, video.cid,
        {
          // set the cookie for only 5 minutes
          expires: 1/288, // 5 minutes is 1/288th of a day
        }
      );
    }

    sendPbsGtmEvent(eventData);
  }

  if(style === 'iconOnly') {
    return (
      <button
        className={styles.my_list_button__icon_only}
        onClick={handleClick}
        >
        <PlusIcon />
        <span className="visuallyhidden">Sign in to add to My List</span>
      </button>
    )
  } else if (style === 'kabobMenu') {
    return (
      <button
        className={styles.my_list_button__kabob_menu}
        onClick={handleClick}
        >
        <PlusIcon />
        <span>Add to My List</span>
      </button>
    )
  } else {
    return (
      <button
        className={styles.my_list_button}
        onClick={handleClick}
        >
        <PlusIcon />
        <span className="visuallyhidden">Sign in to add to</span>
        <span>My List</span>
      </button>
    )
  }
}

export default SignedOutMyListButton
